import { CurrencyPipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { ReitMetadataResponse } from '@kolytics/shared-api';
import { formatCurrency } from '@kolytics/shared-functions';
import { colorPallete, GraphId } from '@kolytics/types/graph';
import {
  IReitOverview,
  IReitOverviewPropertyValueByLocation,
} from '../../../interfaces';
import { TreeMapModule } from '@swimlane/ngx-charts';
import { SectionComponent } from '../../../../../../../../../libs/shared-components/src/lib/components/section/section.component';

@Component({
  selector: 'klt-overview-property-value-location',
  templateUrl: './overview-property-value-location.component.html',
  styleUrls: ['./overview-property-value-location.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SectionComponent, TreeMapModule],
})
export class OverviewPropertyValueLocationComponent {
  single: any[] = [];

  @Input() height = '365px';
  @Input() width = '100%';

  @Input() metadata!: ReitMetadataResponse;
  @Input() countryCode!: string;

  @Input()
  set reit(reit: IReitOverview | undefined) {
    if (reit && reit.propertyValueByLocation.length) {
      reit.propertyValueByLocation.forEach((s, i) => {
        let displayValue =
          s.value > 1000
            ? `${
                formatCurrency(
                  s.value / 1000,
                  0,
                  this.metadata.culture,
                  this.metadata.currencyCode,
                  undefined,
                  this.metadata.currencyFormat,
                ) + 'b'
              }`
            : `${
                formatCurrency(
                  s.value,
                  0,
                  this.metadata.culture,
                  this.metadata.currencyCode,
                  undefined,
                  this.metadata.currencyFormat,
                ) + 'm'
              }`;
        this.single.push({
          name: s.country,
          value: s.value,
          extra: { idx: i, percentage: s.percentage, display: displayValue },
        });
      });
      // const data: IReitOverviewPropertyValueByLocation[] = reit.propertyValueByLocation.sort((a: IReitOverviewPropertyValueByLocation, b: IReitOverviewPropertyValueByLocation) => a.percentage - b.percentage) as IReitOverviewPropertyValueByLocation[];
      // this.buildTreemap(data);
    }
  }

  colorScheme: any = {
    domain: colorPallete[GraphId.OverviewPropertyByLocation],
  };

  customColors = (name: any) => {
    const value = this.single.find((s) => s.name === name).extra.idx;
    return this.colorScheme.domain[value];
  };

  labelFormatting(c: { data: any; label: any }) {
    return `<div class='value-information'>
            <div class='name'>${c.label}</div>
            <div class='total'>
              <div class='total-valueb'>${c.data.extra.display}</div>
              <div class='total-percentb'>(${c.data.extra.percentage}%)</div>
            </div>
          </div>`;
  }
  tooltipDisabled: boolean = false;
  gradient: boolean = false;
  animations: boolean = true;

  constructor(
    protected readonly cdr: ChangeDetectorRef,
    private currencyPipe: CurrencyPipe,
  ) {}

  protected getCurrency(data: any, currencyCode: string, suffix?: string) {
    const value = parseFloat(data);

    let result = '';
    if (currencyCode === 'GBP') {
      result =
        this.currencyPipe.transform(value, currencyCode, 'symbol', '0.0-0') ||
        '';
    }
    result =
      this.currencyPipe.transform(value, currencyCode, 'symbol', '0.0-0') || '';

    result = `${result}${suffix}`;
    return result;
  }
}
